<!--
  <GenericSelector>

  </GenericSelector>

  Props:
    - disabled
    - items
    - current_selected
    - search
    - multiple
    - checkbox
    - required
    - open_menu

  Actions:
    - @item_selected
    - @update

-->

<template>
    <ResponsiveMenuDialog ref="activator" @close="trigger_update">
      <template v-slot:activator="{ toggle }">
        <slot :name="'activator'" :toggle="toggle">
          <v-btn
            @click.stop="pull_selected();toggle()"
            color="primary"
            dark
            icon
            small
            >
            <v-icon small>
              mdi-filter-variant
            </v-icon>
          </v-btn>
        </slot>
      </template>
  
      <template v-slot:content>
        <div class="selector-process-cont">
          <div class="selector-process-header">
            <div 
              class="selector-text-search"
              v-if="search"
            >
            <SearchText
              @input="search_text"
            ></SearchText>
            </div>
            <div>
              <v-btn
                v-if="!required"
                text
                color="primary"
                @click="clear"
              > {{ $vuetify.lang.translator('dialog.clear') }}
              </v-btn>
            </div>
            <div v-if="multiple && selected.length > 0">
              <div
                v-if="selected.length < 4"
              >
                <v-chip
                  v-for="item in selected_items"
                  :key="item.id"
                  color="primary"
                  class="mr-2"
                >
                  {{ item.readable_name ? item.readable_name : item.name }}
                </v-chip>
              </div>
              <div
                v-else
                class="qmkey-generic-process-filter-selection-text"
              >
                {{ `${selected.length} ${$vuetify.lang.translator('filters.processes.processes_selected')}` }}
              </div>
            </div>
          </div>
 
          <div class="selector-process-scrollable-list">
            <v-list>
              <v-list-item-group
                :value="selected_indexes"
                :multiple="multiple"
              >
                <v-list-item
                  v-for="item in current"
                  @click="() => toggle_selection(item)"
                >
                  <template v-slot:default="{ active }">
                    <v-list-item-action v-if="checkbox">
                      <v-checkbox
                        :input-value="active"
                        color="primary"
                      ></v-checkbox>
                    </v-list-item-action>
  
                    <v-list-item-content>
                      <v-list-item-title :style="item.style ? item.style : ''">{{ item.name }}</v-list-item-title>
                    </v-list-item-content>
                  </template>
                </v-list-item>
              </v-list-item-group>
            </v-list>
          </div>
        </div>
      </template>
    </ResponsiveMenuDialog>
  </template>
  
  <style lang="scss">
   @import '@/sass/explorer.scss';
  
   .selector-process-cont {
     background-color: white;
   }
  
   .selector-process-header {
     display: flex;
     gap: 10px;
     align-items: center;
   }
  
   .selector-process-scrollable-list {
     overflow-y: scroll;
     max-height: 50vh;
   }
   .selector-text-search {
    margin: 2px;
   }
  </style>
  
  <script>
   import ResponsiveMenuDialog from '@/components/ResponsiveMenuDialog'
   import SearchText from '@/components/SearchText'
   
   export default {
     name: 'GenericSelector',
  
     components: {
       ResponsiveMenuDialog,
       SearchText,
     },
  
     props: {
      disabled: {
        type: Boolean,
        default: false,
      },
      items: {
        required: true
      },
      current_selected: {
        type: Array, 
        required: false, 
        default: () => []
      },
      search: {
        type: Boolean,
        default: false
      },
      multiple: {
        type: Boolean,
        default: false
      },
      checkbox: {
        type: Boolean,
        default: false
      },
      required: {
        type: Boolean,
        default: false
      },
      open_menu: {
        type: Boolean,
        default: false
      },
     },
  
     data: () => ({
       selected: [],
       local_items: null,
     }),
  
     computed: {
       current(){
        return this.local_items ? this.local_items : this.items;
       },
    
       selected_indexes() {
         return (
           this.current
               .map((it, index) => [it, index])
               .filter(it_index => this.selected.indexOf(it_index[0].id) >= 0)
               .map(it_index => it_index[1])
         );
       },
  
       selected_items() {
         return this.selected.map(id => this.current.find(item => item.id == id));
       },
     },
  
     methods: {
       toggle_selection(item) {
         if (!this.multiple) {
          this.selected = [item.id];
          this.$refs['activator'].close();
         } else {
          const pos = this.selected.indexOf(item.id);
          if (pos < 0) {
            this.selected.push(item.id);
          } else {
            this.selected.splice(pos, 1);
          }
         }
         this.$emit('item_selected',item);
       },  
  
       clear() {
         this.selected = [];
       },
  
       trigger_update() {
         if (this.multiple) {
          this.$emit('update',this.selected);
         } else {
          if (this.selected.length > 0) {
            this.$emit('update', this.selected[0]);
          } else {
            this.$emit('update', null);
          }
         }
         this.selected = [];
       },
  
       pull_selected() {
         this.selected = [...this.current_selected];
       },

       search_text(text) {
        if (text && text !== '') {
          this.local_items = this.items.filter(it => it.name.toLowerCase().includes(text.toLowerCase()));
        } else {
          this.local_items = this.items;
        }
       },
     },
   }
  </script>
  